import FadeContent from '../reactbits/FadeContent';

// 四阶成熟度（正式定稿：初用/惯用/扩散/重构）——固定展示常量，内置于此。
const PHASES = [
  { key: 'p1', sym: 's-ph1', t: '初用期', s: '开始尝试' },
  { key: 'p2', sym: 's-ph2', t: '惯用期', s: '稳定嵌入' },
  { key: 'p3', sym: 's-ph3', t: '扩散期', s: '带动他人' },
  { key: 'p4', sym: 's-ph4', t: '重构期', s: '重构格局' },
];

// 跟随鼠标的紫色光斑：写 --mx/--my CSS 变量（轻量，无组件级 state）。
function handleCellMove(e) {
  const el = e.currentTarget;
  const r = el.getBoundingClientRect();
  el.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
  el.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
}

export default function MaturityMatrix({ forces }) {
  return (
    <section className="matrix-sec">
      <div className="matrix-wrap">
        <FadeContent className="head matrix-head">
          <span className="kicker">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 5h16M4 5v14M20 5v14M4 19h16M9 5v14M14 5v14" /></svg>
            模型说明
          </span>
          <h2 className="section-title">五层领导力 × 四阶成熟度</h2>
          <p className="section-sub">每一层领导力都对应四个成熟阶段，悬停卡片查看该阶段的具体表现。</p>
        </FadeContent>

        <div className="matrix">
          <div className="corner" />
          {PHASES.map((p) => (
            <div className="col-head" key={p.key}>
              <span className="ic"><svg><use href={`#${p.sym}`} /></svg></span>
              <span className="t">{p.t}</span>
              <span className="s">{p.s}</span>
            </div>
          ))}

          {forces.map((f) => (
            <div className="force-block" key={f.code}>
              <div className="row-head">
                <span className="ic"><svg><use href={`#${f.sym}`} /></svg></span>
                <span>
                  <span className="t">{f.name}</span><br />
                  <span className="s">{f.sub}</span>
                </span>
              </div>
              {f.cells.map((text, i) => (
                <div className={`cell ${PHASES[i].key}`} key={PHASES[i].key} onPointerMove={handleCellMove}>
                  <span className="pdot" />
                  <div><span className="ph">{PHASES[i].t}</span>{text}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
